import styles from "../styles/pages.module.css";

export default function AvisoLegal() {
  return (
    <div className={styles.legalPage}>
      <div className={styles.legalContainer}>
        <h1>Aviso Legal</h1>
        <span className={styles.lastUpdated}>Última actualización: abril 2026</span>

        <h2>1. Titularidad del sitio web</h2>
        <p>
          En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se informa que el presente sitio web es titularidad de:
        </p>
        <ul>
          <li><strong>Razón social:</strong> Britosa Mudanzas</li>
          <li><strong>Dirección:</strong> C. Río Duero, 28934 Móstoles, Madrid</li>
          <li><strong>Teléfono:</strong> <a href="tel:+34691604880">691 60 48 80</a></li>
          <li><strong>Correo electrónico:</strong> <a href="mailto:info@mudanzasbritosa.com">info@mudanzasbritosa.com</a></li>
          <li><strong>NIF/CIF:</strong> [Pendiente de completar por el titular]</li>
        </ul>

        <h2>2. Condiciones de uso</h2>
        <p>
          El acceso y uso de este sitio web atribuye la condición de usuario, quien acepta, desde dicho acceso y uso, las condiciones generales de uso aquí reflejadas. El usuario se obliga a hacer un uso correcto del sitio web de conformidad con las leyes, la buena fe, el orden público, los usos del tráfico y el presente aviso legal.
        </p>

        <h2>3. Propiedad intelectual e industrial</h2>
        <p>
          Todos los contenidos de este sitio web (textos, fotografías, gráficos, imágenes, tecnología, software, links, contenidos audiovisuales o de sonido, diseño gráfico, código fuente, etc.), así como las marcas, nombres comerciales o signos distintivos son propiedad del titular o de terceros que han autorizado su inclusión, estando protegidos por la normativa de propiedad intelectual e industrial.
        </p>
        <p>
          Queda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otro acto de explotación de los contenidos sin autorización expresa y por escrito del titular.
        </p>

        <h2>4. Responsabilidad</h2>
        <p>
          El titular no se hace responsable de los daños y perjuicios derivados del acceso, uso o mala utilización de los contenidos, siempre que no haya actuado con dolo o negligencia grave. Tampoco se responsabiliza de fallos, inexactitudes u omisiones en los contenidos, ni de los virus u otros elementos lesivos que pudieran afectar al equipo informático del usuario.
        </p>
        <p>
          Los enlaces a terceros son facilitados únicamente con fines informativos. El titular no controla ni garantiza la licitud, fiabilidad, utilidad, veracidad o actualidad de los contenidos de dichos sitios externos.
        </p>

        <h2>5. Legislación aplicable y jurisdicción</h2>
        <p>
          Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia que pudiera derivarse del acceso o uso del sitio web, el titular y el usuario se someten a los juzgados y tribunales de Madrid, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
        </p>
      </div>
    </div>
  );
}
